export default __webpack_public_path__ + "static/media/rdl_logo_inverse_notext.262827cf.svg";